import React, { useContext } from "react";
import TemplateDataContext from "../../Contexts/TemplateData.context";
import { templateActionEnum } from "../../Config/Constants";

type Props = {};

const PreviewComponent = (props: Props) => {
  const { state, dispatch } = useContext(TemplateDataContext);

  const handleShow = () => {
    dispatch({
      type: templateActionEnum.SET_MODAL_STATE,
      payload: !state.showTemplateModal,
    });
  };

  return (
    <button className="preview-faq-btn" onClick={handleShow}>
      <svg
        width="29"
        height="29"
        viewBox="0 0 29 29"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.8603 13.8575C16.8603 15.2926 15.697 16.4559 14.262 16.4559C12.827 16.4559 11.6637 15.2926 11.6637 13.8575C11.6637 12.4225 12.827 11.2592 14.262 11.2592C15.697 11.2592 16.8603 12.4225 16.8603 13.8575Z"
          stroke="#16283D"
          stroke-width="1.38577"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M5.9978 13.8575C7.10146 10.3436 10.3843 7.7948 14.2624 7.7948C18.1405 7.7948 21.4233 10.3437 22.5269 13.8576C21.4233 17.3715 18.1405 19.9203 14.2624 19.9203C10.3842 19.9203 7.10144 17.3714 5.9978 13.8575Z"
          stroke="#16283D"
          stroke-width="1.38577"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>

      <span>Preview</span>
    </button>
  );
};

export default PreviewComponent;
